import { request } from '../request'
import { Document } from '../types'
import { parsedUrl } from '../utils'

export class DocumentsService {

  createDocument(customerId: number, keywordId: number, document: { fileUrl: string, name: string }): Promise<Document> {
    const u = parsedUrl(document.fileUrl)
    const forServer = {
      file_url: u.protocol + '//' + u.hostname + u.pathname,
      path: u.pathname,
      name: document.name
    }
    return request.post(`/api/customers/${customerId}/keywords/${keywordId}/documents`, { document: forServer })
  }

  removeDocument(customerId: number, keywordId: number, documentId: number) {
    return request.del(`/api/customers/${customerId}/keywords/${keywordId}/documents/${documentId}`)
  }

}
